import { createRouter, createWebHistory } from "vue-router";
import AppLayoutAdmin from "../layouts/AppLayoutAdmin.vue";
import LoginView from "@/views/login/LoginView.vue";
import RegisterView from "@/views/login/RegisterView.vue";
import MapsView from "@/views/maps/MapsView.vue";
import KuotaView from "@/views/kuota/KuotaView.vue";
import OrderView from "@/views/order/OrderView.vue";
import PostOrderView from "@/views/postOrder/PostOrderView.vue";
import SgnksoView from "@/views/sgnkso/SgnksoView.vue";
import SgnTotalView from "@/views/sgnTotal/SgnTotalView.vue";
import DailySceneView from "@/views/dailyScene/DailySceneView.vue";
import DashboardView from "@/views/dashboard/DashboardView.vue";
import SceneCalendar from "@/views/sceneCalendar/SceneCalendar.vue";
import UserView from "@/views/user/UserView.vue";
import {
  useAlertStore,
  useAuthStore,
  useScrollStore,
  useSidebarStore,
} from "@/store";
import OrderStatusView from "@/views/orderStatus/OrderStatusView.vue";
import PostOrderStatusView from "@/views/postOrderStatus/PostOrderStatusView.vue";

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      authPage: true,
    },
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView,
    meta: {
      authPage: true,
    },
  },
  {
    path: "/",
    name: "AppLayout",
    component: AppLayoutAdmin,
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          requireAuth: true,
        },
        component: DashboardView,
      },
      {
        path: "/maps",
        name: "maps",
        meta: {
          requireAuth: true,
        },
        children: [
          {
            path: "",
            name: "maps",
            component: MapsView,
          },
          {
            path: ":kode_petak",
            name: "maps-scene",
            component: DailySceneView,
          },
        ],
      },
      // {
      //   path: "/scene/:feature_id",
      //   name: "scene",
      //   component: DailySceneView,
      //   meta: {
      //     requireAuth: true,
      //   },
      // },
      {
        path: "/kuota",
        name: "kuota",
        component: KuotaView,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/order",
        name: "order",
        component: OrderView,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/post-order",
        name: "post-order",
        component: PostOrderView,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/sgn-kso",
        name: "sgn-kso",
        component: SgnksoView,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/sgn-total",
        name: "sgn-total",
        component: SgnTotalView,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/scene-calendar",
        name: "scene-calendar",
        component: SceneCalendar,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/users",
        name: "users",
        component: UserView,
        meta: {
          requireAdmin: true,
        },
      },
      {
        path: "/order-status",
        name: "order-status",
        component: OrderStatusView,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/post-order-status",
        name: "post-order-status",
        component: PostOrderStatusView,
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const alertStore = useAlertStore();
  const sidebarStore = useSidebarStore();
  const scroll = useScrollStore();

  alertStore.clear();
  sidebarStore.$reset();
  scroll.$reset();

  const authStore = useAuthStore();

  if (to.meta.authPage) {
    if (!authStore.user) {
      next();
    } else {
      next(from);
    }
  }

  if (to.meta.requireAuth) {
    if (authStore.user) {
      next();
    } else {
      next({ name: "login" });
    }
  }

  if (to.meta.requireAdmin) {
    if (authStore.user) {
      if (authStore.user.role == "admin") {
        next();
      } else {
        next({ name: "dashboard" });
      }
      next();
    } else {
      next({ name: "login" });
    }
  }
});

export default router;
